// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
import type { DamRef } from '../types.ts';

export const DAMS: DamRef[] = [
  // NSW — Murray-Darling & Snowy Mountains
  {
    id: 'eucumbene',
    name: 'Lake Eucumbene',
    state: 'NSW',
    capacity_ml: 4_798_400,
    lat: -36.113,
    lon: 148.673,
    authority: 'Snowy Hydro',
    station_no: '222538',
  },
  {
    id: 'hume',
    name: 'Lake Hume',
    state: 'NSW/VIC',
    capacity_ml: 3_005_157,
    lat: -36.107,
    lon: 147.031,
    authority: 'Murray-Darling Basin Authority',
    station_no: '401027',
  },
  {
    id: 'warragamba',
    name: 'Warragamba Dam',
    state: 'NSW',
    capacity_ml: 2_027_000,
    lat: -33.889,
    lon: 150.594,
    authority: 'WaterNSW',
    station_no: '212212',
  },
  {
    id: 'burrendong',
    name: 'Burrendong Reservoir',
    state: 'NSW',
    capacity_ml: 1_188_000,
    lat: -32.677,
    lon: 149.130,
    authority: 'WaterNSW',
    station_no: '421078',
  },
  {
    id: 'blowering',
    name: 'Blowering Reservoir',
    state: 'NSW',
    capacity_ml: 1_631_000,
    lat: -35.560,
    lon: 148.238,
    authority: 'Snowy Hydro',
    station_no: '412107',
  },
  {
    id: 'copeton',
    name: 'Copeton Reservoir',
    state: 'NSW',
    capacity_ml: 1_361_000,
    lat: -29.823,
    lon: 151.019,
    authority: 'WaterNSW',
    station_no: '418035',
  },
  {
    id: 'burrinjuck',
    name: 'Burrinjuck Reservoir',
    state: 'NSW',
    capacity_ml: 1_026_000,
    lat: -34.969,
    lon: 148.583,
    authority: 'WaterNSW',
    station_no: '410131',
  },
  {
    id: 'keepit',
    name: 'Keepit Reservoir',
    state: 'NSW',
    capacity_ml: 425_510,
    lat: -30.889,
    lon: 150.511,
    authority: 'WaterNSW',
    station_no: '419041',
  },
  {
    id: 'windamere',
    name: 'Lake Windamere',
    state: 'NSW',
    capacity_ml: 368_120,
    lat: -32.691,
    lon: 149.793,
    authority: 'WaterNSW',
    station_no: '421148',
  },
  {
    id: 'glenbawn',
    name: 'Glenbawn Reservoir',
    state: 'NSW',
    capacity_ml: 750_000,
    lat: -32.020,
    lon: 151.074,
    authority: 'WaterNSW',
    station_no: '210097',
  },
  // ACT
  {
    id: 'googong',
    name: 'Googong Reservoir',
    state: 'ACT',
    capacity_ml: 121_400,
    lat: -35.545,
    lon: 149.228,
    authority: 'Icon Water',
    station_no: '410748',
  },
  // VIC
  {
    id: 'dartmouth',
    name: 'Lake Dartmouth',
    state: 'VIC',
    capacity_ml: 3_856_232,
    lat: -36.529,
    lon: 147.499,
    authority: 'AGL Hydro',
    station_no: '401224A',
  },
  {
    id: 'eildon',
    name: 'Lake Eildon',
    state: 'VIC',
    capacity_ml: 3_334_158,
    lat: -37.181,
    lon: 146.013,
    authority: 'Goulburn-Murray Water',
    station_no: 'sp-o10334',
  },
  {
    id: 'thomson',
    name: 'Thomson Reservoir',
    state: 'VIC',
    capacity_ml: 1_068_000,
    lat: -37.754,
    lon: 146.231,
    authority: 'Melbourne Water',
    station_no: '225256A',
  },
  {
    id: 'cardinia',
    name: 'Cardinia Reservoir',
    state: 'VIC',
    capacity_ml: 286_000,
    lat: -37.991,
    lon: 145.591,
    authority: 'Melbourne Water',
    station_no: '228263A',
  },
  // QLD
  {
    id: 'wivenhoe',
    name: 'Lake Wivenhoe',
    state: 'QLD',
    capacity_ml: 1_165_238,
    lat: -27.390,
    lon: 152.608,
    authority: 'Seqwater',
    station_no: '143036A',
  },
  {
    id: 'somerset',
    name: 'Somerset Dam',
    state: 'QLD',
    capacity_ml: 379_849,
    lat: -27.098,
    lon: 152.563,
    authority: 'Seqwater',
    station_no: '143305A',
  },
  {
    id: 'hinze',
    name: 'Hinze Dam',
    state: 'QLD',
    capacity_ml: 310_730,
    lat: -28.035,
    lon: 153.275,
    authority: 'Seqwater',
    station_no: '146033A',
  },
  {
    id: 'north_pine',
    name: 'North Pine Dam',
    state: 'QLD',
    capacity_ml: 214_302,
    lat: -27.268,
    lon: 152.956,
    authority: 'Seqwater',
    station_no: '142801A',
  },
  // SA
  {
    id: 'mt_bold',
    name: 'Mount Bold Reservoir',
    state: 'SA',
    capacity_ml: 46_200,
    lat: -35.130,
    lon: 138.707,
    authority: 'SA Water',
    station_no: 'SAWMTBORS.1',
  },
  {
    id: 'happy_valley',
    name: 'Happy Valley Reservoir',
    state: 'SA',
    capacity_ml: 11_600,
    lat: -35.067,
    lon: 138.527,
    authority: 'SA Water',
    station_no: 'SAWHAPVRS.1',
  },
  // WA
  {
    id: 'mundaring',
    name: 'Mundaring Weir',
    state: 'WA',
    capacity_ml: 63_600,
    lat: -31.904,
    lon: 116.165,
    authority: 'Water Corporation',
    station_no: 'PI_230045.1',
  },
  {
    id: 'serpentine',
    name: 'Serpentine Reservoir',
    state: 'WA',
    capacity_ml: 137_580,
    lat: -32.386,
    lon: 116.094,
    authority: 'Water Corporation',
    station_no: 'PI_238185.1',
  },
  {
    id: 'north_dandalup',
    name: 'North Dandalup Reservoir',
    state: 'WA',
    capacity_ml: 60_800,
    lat: -32.684,
    lon: 116.212,
    authority: 'Water Corporation',
    station_no: 'PI_14564.1',
  },
  // TAS
  {
    id: 'gordon',
    name: "Lake Gordon",
    state: 'TAS',
    capacity_ml: 12_359_300,
    lat: -42.656,
    lon: 146.038,
    authority: 'Hydro Tasmania',
    station_no: '646.1',
  },
  {
    id: 'great_lake',
    name: 'Great Lake',
    state: 'TAS',
    capacity_ml: 2_274_000,
    lat: -41.919,
    lon: 146.714,
    authority: 'Hydro Tasmania',
    station_no: '139.2',
  },
];

export const STATE_ORDER = ['NSW', 'NSW/VIC', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'ACT'];
